<!--Old UI without doctor note audio-->
@if (!showNewUI) {
  <div class="tw-bg-teal-700 tw-px-4 tw-pt-6 tw-pb-8" (click)="openNutraBottomSheet()">
    <!--  heading -->
    <div class="tw-flex tw-mb-4">
      <img class="tw-w-6 tw-aspect-square" src="/assets/gifs/white-lightning-dar-teal-bg.gif" />
      <!-- Face heading (shown when FACE is present, which covers both FACE only and FACE+HAIR cases) -->
      @if (regimensClass?.includes('FACE')) {
        <div class="tw-text-500 tw-font-bold tw-text-white tw-font-lexend">
          @switch (nutraPushBottomSheetData?.margId) {
            @case ('A00211') {
              <h1 i18n="@@getGlowingEvenTonedSkin">Get Glowing, Even-Toned Skin</h1>
            }
            @case ('A00194') {
              <h1 i18n="@@forBrighterEvenSkin">For brighter &amp; even skin</h1>
            }
            @case ('A00210') {
              <h1 i18n="@@forGlowingFirmYouthful">For Glowing, Firm, Youthful Skin</h1>
            }
            @case ('A00212') {
              <h1 i18n="@@achieveClearerStringerSkin">Achieve Clearer, Stronger Skin</h1>
            }
            @default {
              <h1 i18n="@@getGlowingEvenTonedSkin">Get Glowing, Even-Toned Skin</h1>
            }
          }
        </div>
      }
      <!-- Hair heading (shown only when HAIR is present and FACE is not) -->
      @if (!regimensClass?.includes('FACE') && regimensClass?.includes('HAIR')) {
        <div class="tw-text-500 tw-font-bold tw-text-white tw-font-lexend">
          @switch (nutraPushBottomSheetData?.margId) {
            @case ('A00211') {
              <h1 i18n="@@getGlowingEvenTonedSkin">Get Glowing, Even-Toned Skin</h1>
            }
            @case ('A00194') {
              <h1 i18n="@@forStrongerHealthierHair">For Stronger, Healthier Hair</h1>
            }
            @case ('A00210') {
              <h1 i18n="@@forStrongerRootsFullerHair">Get Stronger Roots, Fuller Hair</h1>
            }
            @case ('A00212') {
              <h1 i18n="@@strongerRootsHealthierScalp">Stronger Roots, Healthier Scalp</h1>
            }
            @default {
              <h1 i18n="@@forStrongerHealthierHair">For Stronger, Healthier Hair</h1>
            }
          }
        </div>
      }
    </div>
    <!--  Nutra Banner Container-->
    <div class="tw-flex tw-w-full tw-rounded-3 tw-overflow-hidden tw-bg-gradient-white-to-gray">
      <div class="tw-w-full tw-pt-[22px] tw-pb-5">
        <div class="tw-max-w-[155px] tw-ml-4 tw-mb-4">
          <h1 class="tw-text-500 tw-text-bold tw-font-lexend tw-mb-1">{{nutraPushBottomSheetData?.title}}</h1>
          <!-- Face sub title (shown when FACE is present, which covers both FACE only and FACE+HAIR cases) -->
          @if (regimensClass?.includes('FACE')) {
            <div class="tw-text-200 tw-text-gray-750 tw-font-medium tw-leading-[14px]">
              @switch (nutraPushBottomSheetData?.margId) {
                @case ('A00211') {
                  <p i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
                }
                @case ('A00194') {
                  <p i18n="@@myoPushBannerFaceSubTitle">2 out of 3 users achieved clearer skin, reduced acne</p>
                }
                @case ('A00210') {
                  <p i18n="@@vitalPushBannerFaceSubTitle">A powerful blend of Biotin, Amino Acids, Vitamins &amp; Minerals</p>
                }
                @case ('A00212') {
                  <p i18n="@@omegaPushBannerFaceSubTitle">Say goodbye to flare-ups, breakouts and dryness</p>
                }
                @default {
                  <p i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
                }
              }
            </div>
          }
          <!-- Hair sub title (shown only when HAIR is present and FACE is not) -->
          @if (!regimensClass?.includes('FACE') && regimensClass?.includes('HAIR')) {
            <div class="tw-text-200 tw-text-gray-750 tw-font-medium tw-leading-[14px]">
              @switch (nutraPushBottomSheetData?.margId) {
                @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.GLUTA) {
                  <p i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
                }
                @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.MYO) {
                  <p i18n="@@myoPushBannerHairSubTitle">3 out of 5 noticed stronger hair &amp; lesser hair fall</p>
                }
                @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.VITAL) {
                  <p i18n="@@vitalPushBannerHairSubTitle">Daily nourishment for your hair from the inside out</p>
                }
                @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA) {
                  <p i18n="@@omegaPushBannerHairSubTitle">When your scalp is balanced and nourished, great hair follows</p>
                }
                @default {
                  <p i18n="@@myoPushBannerHairSubTitle">3 out of 5 noticed stronger hair &amp; lesser hair fall</p>
                }
              }
            </div>
          }
        </div>
        <div class="tw-ml-4 tw-text-300 tw-font-bold tw-text-white tw-bg-teal-600 tw-w-fit tw-py-2 tw-px-4 tw-rounded-2 tw-leading-[16px]" i18n="@@knowMore">Know More</div>
      </div>
      <div class="tw-w-[165px] tw-flex-shrink-0 tw-flex tw-justify-end tw-items-end">
        <img class="tw-w-[165px]" [src]="nutraPushBannerData?.coverImage" />
      </div>
    </div>
  </div>
}

<!--New UI with doctor note audio-->
@if (showNewUI) {
  <div class="tw-px-4 tw-py-5 tw-bg-white" (click)="openNutraBottomSheet()">
    <!--  heading  -->
    <div class="tw-flex tw-gap-2 tw-items-center tw-mb-4">
      <img alt="icon" src="/assets/icons/orange_tick_new.svg" class="tw-w-4 tw-aspect-square">
      <h1 class="tw-uppercase tw-tracking-[1.5px] tw-font-medium tw-font-body" i18n="@@recommendedByYourDoctor">Recommended by your doctor</h1>
    </div>
    <!--  card  -->
    <div class="tw-w-full tw-rounded-3 tw-bg-gradient-white-to-gray tw-relative tw-min-h-[192px] tw-flex tw-flex-col tw-justify-between">
      <!--text content-->
      <div class="tw-pl-4 tw-pb-4"
        [ngClass]="{ 'tw-pt-[17px] lg:tw-pt-[27px]': nutraPushBottomSheetData?.margId === appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA, 'tw-pt-[27px]': nutraPushBottomSheetData?.margId != appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA,  }"
        >
        <div class="tw-w-[calc(100%-140px)] sm:tw-pr-1 lg:tw-pr-4">
          <h1 class="tw-text-[clamp(1.33rem,4vw,2rem)] tw-font-[700] tw-font-lexend tw-mb-2">{{ nutraPushBottomSheetData?.margId === appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.MYO ? nutraPushBannerData?.title : nutraPushBottomSheetData?.title}}</h1>
          <!-- Face sub title (shown when FACE is present, which covers both FACE only and FACE+HAIR cases) -->
          @if (regimensClass?.includes('FACE')) {
            <div class="tw-text-[clamp(0.835rem,3vw,1rem)] tw-text-gray-750 tw-font-medium tw-line-clamp-2 tw-text-ellipsis">
              @switch (nutraPushBottomSheetData?.margId) {
                @case ('A00211') {
                  <p i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
                }
                @case ('A00194') {
                  <p i18n="@@myoPushBannerFaceSubTitle">2 out of 3 users achieved clearer skin, reduced acne</p>
                }
                @case ('A00210') {
                  <p i18n="@@vitalPushBannerFaceSubTitle">A powerful blend of Biotin, Amino Acids, Vitamins &amp; Minerals</p>
                }
                @case ('A00212') {
                  <p i18n="@@omegaPushBannerFaceSubTitle">Say goodbye to flare-ups, breakouts and dryness</p>
                }
                @default {
                  <p i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
                }
              }
            </div>
          }
          <!-- Hair sub title (shown only when HAIR is present and FACE is not) -->
          @if (!regimensClass?.includes('FACE') && regimensClass?.includes('HAIR')) {
            <div class="tw-text-[clamp(0.835rem,3vw,1rem)] tw-text-gray-750 tw-font-medium tw-leading-4 tw-line-clamp-2 tw-text-ellipsis">
              @switch (nutraPushBottomSheetData?.margId) {
                @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.GLUTA) {
                  <p i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
                }
                @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.MYO) {
                  <p i18n="@@myoPushBannerHairSubTitle">3 out of 5 noticed stronger hair &amp; lesser hair fall</p>
                }
                @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.VITAL) {
                  <p i18n="@@vitalPushBannerHairSubTitle">Daily nourishment for your hair from the inside out</p>
                }
                @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA) {
                  <p i18n="@@omegaPushBannerHairSubTitle">When your scalp is balanced and nourished, great hair follows</p>
                }
                @default {
                  <p i18n="@@myoPushBannerHairSubTitle">3 out of 5 noticed stronger hair &amp; lesser hair fall</p>
                }
              }
            </div>
          }
        </div>
        <p class="tw-font-[700] tw-text-teal-600 tw-text-[clamp(0.835rem,3vw,1rem)] tw-leading-4 tw-lowercase first-letter:tw-uppercase" i18n="@@knowMore">Know More</p>
      </div>
      <!--    audio -->
      <div class="tw-px-4 tw-w-full tw-pb-3 tw-relative tw-z-[2]">
        <div class="tw-rounded-full tw-overflow-hidden">
          @if (regimensClass?.includes('FACE') && !!drFaceAudioNote) {
            <c-audio [newUI]=true [src]="drFaceAudioNote"
            [imageUrl]="drInfo?.imageUrl" [eventPrefix]="'nutra_push_face'" ></c-audio>
          }
          @if (!regimensClass?.includes('FACE') && regimensClass?.includes('HAIR') && !!drHairAudioNote) {
            <c-audio [newUI]=true [src]="drHairAudioNote"
            [imageUrl]="drInfo?.imageUrl" [eventPrefix]="'nutra_push_hair'"></c-audio>
          }
        </div>
      </div>
      <!--    bg image  -->
      <div class="tw-absolute tw-z-[1] tw-bottom-0 tw-right-0 tw-w-max tw-flex-shrink-0 tw-flex tw-justify-end tw-items-end">
        <img class="tw-rounded-3 tw-h-[192px]" [src]="nutraPushBannerData?.coverImageV2" id="nutra product">
      </div>
    </div>
  </div>
}
